import axios from 'axios';

// 通信の基本設定を行います
const httpClient = axios.create({
  timeout: 30000,
  withCredentials: true,
});

export { httpClient as default };
